import { ParagraphBlockProps } from "./types";
import ParagraphWeb from "./web";

export function ParagraphWebEditor(props: ParagraphBlockProps) {
  return <ParagraphWeb {...props} isEditor />;
}
